export default "__VITE_ASSET__DJS$xb6P__"